import {
  LOGIN_USER,
  FORGOT_PWD,
  CHANGE_PWD,
  SHOW_TOAST,
  LOGOUT_USER,
  LOGGED_USER,
  SWITCH_USER,
  SWITCH_DATA
} from '@redux/types';

// Show Toast
export const showToast = (msg) => {
  return (dispatch) => {
    dispatch({ type: SHOW_TOAST, payload: msg });
  };
};

// LOGIN USER
export const loginUserRequest = (user, pass) => ({
  type: LOGIN_USER.START,
  user,
  pass
});

export const loginUserInProgress = () => ({
  type: LOGIN_USER.IN_PROGRESS
});

export const loginUserSuccess = (payload) => ({
  type: LOGIN_USER.SUCCESS,
  payload
});

export const loginUserFailure = () => ({
  type: LOGIN_USER.FAILURE
});

// FORGOT USER

export const forgotPasswordUserRequest = (payload) => ({
  type: FORGOT_PWD.START,
  payload
});

export const forgotPasswordUserInProgress = () => ({
  type: FORGOT_PWD.IN_PROGRESS
});

export const forgotPasswordUserSuccess = (payload) => ({
  type: FORGOT_PWD.SUCCESS,
  payload
});

export const forgotPasswordUserFailure = () => ({
  type: FORGOT_PWD.FAILURE
});

// FORGOT USER

export const changePasswordUserRequest = (payload) => ({
  type: CHANGE_PWD.START,
  payload
});

export const changePasswordUserInProgress = () => ({
  type: CHANGE_PWD.IN_PROGRESS
});

export const changePasswordUserSuccess = (payload) => ({
  type: CHANGE_PWD.SUCCESS,
  payload
});

export const changePasswordUserFailure = () => ({
  type: CHANGE_PWD.FAILURE
});

// LOGOUT USER

export const logoutUserRequest = (payload) => ({
  type: LOGOUT_USER.START,
  payload
});

export const logoutUserInProgress = () => ({
  type: LOGOUT_USER.IN_PROGRESS
});

export const logoutUserSuccess = (payload) => ({
  type: LOGOUT_USER.SUCCESS,
  payload
});

export const logoutUserFailure = () => ({
  type: LOGOUT_USER.FAILURE
});

// LOGGED USER

export const loggedUserRequest = (payload) => ({
  type: LOGGED_USER.START,
  payload
});

export const loggedUserInProgress = () => ({
  type: LOGGED_USER.IN_PROGRESS
});

export const loggedUserSuccess = (payload) => ({
  type: LOGGED_USER.SUCCESS,
  payload
});

// Switch user id
export const switchUserId = () => ({
  type: SWITCH_USER
});

// switch dataset for demo
export const switchDataSet = () => ({
  type: SWITCH_DATA
});

export const loggedUserFailure = () => ({
  type: LOGGED_USER.FAILURE
});
